import { resetReducerKeys } from '../../constants/app-constants';
import { C2bListingService } from '../../services';
import types from './types';

const setRecentSearches = (data) => (
    {
        type: types.SET_RECENT_SEARCHES,
        data
    }
);
const resetSearch = () => ({
    type: resetReducerKeys.RESET_SEARCH
});
const getAuctionDetails = (payload) => () => {
    return new Promise((resolve, reject) => {
        C2bListingService.fetchAuctionDetail(payload)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            });
    });
};
const getAutoSuggestions = (str) => () => {
    return new Promise((resolve, reject) => {
        C2bListingService.fetchSuggestedSearch(str)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            });
    });
};
export {
    getAuctionDetails,
    setRecentSearches,
    resetSearch,
    getAutoSuggestions
};
